import React from "react";
import {AlertMessage} from "../../../components";
import "./_alert-banner.scss";

interface AlertBannerProps {
    message: string,
    detail: string
}

const AlertBanner = ({message, detail}: AlertBannerProps): JSX.Element => {
    return (
        <div className="row-container alert-banner">
            <AlertMessage
                className="display-flex justify-content-right alertBanner"
                id="alertBanner"
                fullWidth={false}
                icon="warning"
                showAlert={true}
                showCloseBtn={false}
                type="error"
            >
                <b className="alert-banner-message">{message}</b>
                &nbsp;
                <b className="alert-banner-detail">{detail}</b>
            </AlertMessage>
        </div>
    );
};

export default AlertBanner;